import { useState, useEffect } from 'react';

const useCurrentTime = (options = {}) => {
  const { 
    interval = 2000, 
    enabled = true,
    format = 'date'
  } = options;
  
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    if (!enabled) return;
    
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, interval);

    return () => clearInterval(timer);
  }, [interval, enabled]);

  if (format === 'timestamp') {
    return currentTime.getTime();
  } else if (format === 'formatted') {
    return currentTime.toLocaleString();
  }
  
  return currentTime;
};

export default useCurrentTime;